import {Component, HostListener, OnInit} from '@angular/core';
import {AuthService} from "../services/accounts/auth.service";
import {CustomHttpService} from "../services/custom-http.service";
import { NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject, takeUntil } from 'rxjs';
import { ThemeService } from '../services/theme.service';
import { CurrencyService } from '../services/currency.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit{

  user: any = {}
  company:any = {};
  isProfilePage: boolean = false;
  showDropdown: boolean = false;
  displayCurrency: string = 'KES';
  convertedBalance: number | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    public auth: AuthService,
    public customHTTP: CustomHttpService,
    private router: Router,
    private modalService: NgbModal,
    public themeService: ThemeService,
    public currencyService: CurrencyService
  ) {}

  private recomputeBalance() {
    const d = this.currencyService.display(this.company?.account_balance);
    this.displayCurrency = d.currency;
    this.convertedBalance = d.amount;
  }

  logout() {
    this.auth.logout()
  }

  @HostListener('document:click')
  closeDropdown() {
    this.showDropdown = false;
  }

  toggleDropdown(event?: Event){
    event?.stopPropagation();
    this.showDropdown = !this.showDropdown
  }
  navigateToUserProfile(){
    this.router.navigate(['/userprofile'])
  }

  /** Re-reads the decoded identity and re-fetches the balance off the current token.
   *  Called on init and again on every AuthService.identityChanged$ emission (login,
   *  or a silent refresh) — without this, a refreshed token never gets reflected here. */
  private loadIdentity() {
    this.user = this.auth.user();
    this.customHTTP.getBalance(this.auth.getUserCompanyId())
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        {
          next: (data) => { this.company = data; this.recomputeBalance() },
          error: (err) => console.error('Error fetching balance:', err)
        }
    )
  }

  ngOnInit() {
    this.loadIdentity();
    this.auth.identityChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadIdentity());
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        let currentRoute = this.router.url;  // Full URL path
        // if (currentRoute == '/userprofile') {
        //   this.isProfilePage = true
        // } else {
        //   this.isProfilePage = false
        // }
      });
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
